import { ICityLiteAsset } from "models/Assets/ICityAsset";
import { AllowedCitiesTypes } from "contexts/AssetsContext";

const defaultFields = ["id", "order"];

const fields_ar = [...defaultFields, "url_name_ar","url_name_en", "name_arabic"];

const fields_en = [...defaultFields, "url_name_en", "name_english"];

export const toLiteCity = (city: AllowedCitiesTypes, lang): ICityLiteAsset => {
  const object = {};
  (lang === "en" ? fields_en : fields_ar).forEach((field) => {
    object[field] = city[field];
  });
  return object as ICityLiteAsset;
};

export const toLiteCities =
  (lang = null) =>
  (cities: AllowedCitiesTypes[]): ICityLiteAsset[] => {
    return cities.map((city) => toLiteCity(city, lang));
  };
